import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
import "./purchases-history-view.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import PenImg from "./../../../assets/images/pen.jpg";
let PurchasesHistoryView = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={6}>
              <h1 className="purchases-history-view-list-heading">
                Order date : 18 jun 2022
              </h1>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={6}>
              <h1 className="purchases-history-view-list-heading">
                Order ID : #123456
              </h1>
            </Grid>
            <Grid item xl={4} lg={4} md={8} sm={8} xs={8}>
              <h1 className="purchases-history-view-list-heading">
                User Name : Willow Anderson{" "}
              </h1>
            </Grid>
            <Grid item xl={2} lg={2} md={4} sm={4} xs={4}>
              <div className="purchases-history-view-paid-container">
                <div className="purchases-history-view-paid-button">Paid</div>
              </div>
            </Grid>
            <br />
            <br />
            <Grid item xl={3} lg={3} md={6} sm={6} xs={6}>
              <h1 className="purchases-history-view-list-heading">
                Shipping Address
              </h1>
              <p className="purchases-history-view-list-details">
                1 Sheikh Mohammed bin Rashid Blvd - Downtown Dubai - Dubai -
                United Arab Emirates
              </p>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={6}>
              <h1 className="purchases-history-view-list-heading">
                Payment Method
              </h1>
              <p className="purchases-history-view-list-details">
                HDFC Netbanking
              </p>
            </Grid>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <h1 className="purchases-history-view-list-heading">
                Order Summary
              </h1>
              <div className="purchases-history-view-summary-list">
                <p className="purchases-history-view-summary-list-title">
                  Item Subtotal
                </p>
                <p className="purchases-history-view-summary-list-value">
                  $2000
                </p>
              </div>
              <div className="purchases-history-view-summary-list">
                <p className="purchases-history-view-summary-list-title">
                  Shipping
                </p>
                <p className="purchases-history-view-summary-list-value">0</p>
              </div>
              <div className="purchases-history-view-summary-list">
                <p className="purchases-history-view-summary-list-title">
                  Total
                </p>
                <p className="purchases-history-view-summary-list-value">
                  $2000
                </p>
              </div>
              <div className="purchases-history-view-summary-list">
                <p className="purchases-history-view-summary-list-grand-title">
                  Grand Total
                </p>
                <p className="purchases-history-view-summary-list-grand-value">
                  $2000
                </p>
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <br />
        <hr /> <br />
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={4} sm={12} xs={12}>
              <img src={PenImg} className="purchases-history-view-product-image"/>
            </Grid>
            <Grid item xl={9} lg={9} md={8} sm={12} xs={12}>
              <h1 className="purchases-history-view-product-heading">Classmate Octane Colour Burst - Count of 10 (assorted)</h1>
              <p className="purchases-history-view-product-description">
                massa arcu aliquet nisl, id aliquet ligula risus et dui. Sed ac
                sollicitudin eros, id ultricies est. Morbi auctor arcu at semper
                imperdiet. Donec interdum non eros eu accumsan.
              </p>
              <h1 className="purchases-history-view-product-price">$2000</h1>
            </Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default PurchasesHistoryView;
